<style global lang="postcss">
  /* purgecss start ignore */
  @tailwind base;
  @tailwind components;
  /* purgecss end ignore */

  @tailwind utilities;
</style>
<script>
  import { getContext, setContext } from 'svelte';
  import { writable } from 'svelte/store';
  import LoadProfileHome from './LoadProfile/LoadProfileHome.svelte';
  import LoadProfileHeader from './LoadProfile/LoadProfileHeader.svelte';
  import ProfileCard from './ProfileCard/ProfileCard.svelte';
  import FixedContent from './FixedContent/FixedContent.svelte';
  import ContentBox from './ContentBox/ContentBox.svelte';
  import MatchData from './MatchData/MatchData.svelte';
  import ViewNavigation from './ViewNavigation/ViewNavigation.svelte';
  import Graphs from './Graphs/Graphs.svelte';

  let state = writable({
    nickname: '',
    loading: {
      playerData: false,
      fromMatchData: false,
    },
    view: 'table',
    data: {
      playerData: null,
      playerStats: null,
      matchDisplay: null,
    },
    disableEvents: window.location.host === 'localhost:8080' ? true : false,
  });
  setContext('state', state);
</script>

<div class="bg" />
<div class="app">
  <div class="bg-gray-700  py-2  px-2  md:px-12  flex  justify-between  items-center">
    <h1 class="font-bold  text-white">csgostats.info <sup class="text-green-500">beta</sup></h1>
  </div>

  {#if !$state.loading.playerData && $state.data.playerData && $state.data.playerStats && $state.data.playerData.player_id && $state.data.playerStats.player_id}
    <LoadProfileHeader />
  {:else}
    <LoadProfileHome />
  {/if}

  {#if !$state.loading.playerData && $state.data.playerData && $state.data.playerStats && $state.data.playerData.player_id && $state.data.playerStats.player_id}
    <FixedContent>
      <br />
      <div class="flex  justify-between  items-center">
        <div style="width: 850px">
          <ContentBox>
            <ProfileCard />
          </ContentBox>
        </div>
      </div>
    </FixedContent>
  {/if}

  <!-- Get Matches -->
  {#if !$state.loading.playerData && $state.data.playerData && $state.data.playerData.player_id}
    <br />
    <ViewNavigation />
    <br />
    {#if $state.view === 'table'}
      <MatchData playerId={$state.data.playerData.player_id} />
    {/if}
    {#if $state.view === 'graphs'}
      <Graphs />
    {/if}
  {/if}
</div>
